<template>
    <div v-if="profile?.editMode">
        <EditSkillSetSection />
        <EditIndustryExpertiseSection v-if="sectionVisibility[SectionsVisibilityType.INDUSTRY_EXPERTISE]" />
        <EditCertificationSection />
        <EditEducationSection />
        <AddEducationSection />
        <EditResumeImportFunnel />
        <EditSelectModeExperiences />
        <EditCategories />
        <EditReputationSection v-if="sectionVisibility[SectionsVisibilityType.EXTERNAL_REPUTATION]" />
        <EditPhotoSection />
        <EditRecommendations />

        <!-- Onboarding dialogs -->
        <MaltStrategyOnboarding />
    </div>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import AddEducationSection from '~/components/edit/AddEducationSection.vue';
    import EditCategories from '~/components/edit/categories/EditCategories.vue';
    import EditCertificationSection from '~/components/edit/certifications/EditCertificationSection.vue';
    import EditEducationSection from '~/components/edit/EditEducationSection.vue';
    import EditIndustryExpertiseSection from '~/components/edit/EditIndustryExpertiseSection.vue';
    import EditPhotoSection from '~/components/edit/EditPhotoSection.vue';
    import EditReputationSection from '~/components/edit/EditReputationSection.vue';
    import EditSelectModeExperiences from '~/components/edit/experiences/EditSelectModeExperiences.vue';
    import EditRecommendations from '~/components/edit/recommendations/EditRecommendations.vue';
    import EditSkillSetSection from '~/components/edit/skill-set/EditSkillSetSection.vue';
    import MaltStrategyOnboarding from '~/components/onboarding/MaltStrategyOnboarding.vue';
    import EditResumeImportFunnel from '~/features/resume-import/ui/EditResumeImportFunnel.vue';
    import {useProfileStore} from '~/store/profileStore';
    import {useSectionsVisibilityStore} from '~/store/sectionsVisibility';
    import {SectionsVisibilityType} from '~/types/domain/SectionsVisibility';

    // Stores
    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);
    const {sectionVisibility} = storeToRefs(useSectionsVisibilityStore());
</script>
